core-input-text {
  display: block;
}

.core-input-text {
  --border-width: 1px;
  --outline-width: 2px;
  --outline-offset: 2px;
  display: flex;
}

.core-input-text .input-text-wrapper {
  position: relative;
}

.core-input-text.input-text-disabled .input-text-field {
  pointer-events: none;
  background: var(--color-global-all-disabled-soft);
  color: var(--color-global-all-disabled-strong);
  border-color: transparent;
}

.core-input-text.input-text-disabled:hover {
  cursor: not-allowed;
}

.core-input-text.input-text-format--inside .input-text-field {
  padding: calc(var(--number-spacing-3xsmall) - var(--border-width)) calc(var(--number-spacing-2xsmall) - var(--border-width));
}

.core-input-text.input-text-format--outside .input-text-field, .core-input-text.input-text-format--aside .input-text-field, .core-input-text.input-text-format--hidden .input-text-field {
  padding: calc(var(--number-spacing-2xsmall) - var(--border-width));
}

.core-input-text.input-text-format--outside {
  flex-direction: column;
}

.core-input-text.input-text-format--aside {
  flex-direction: row;
}

.core-input-text.input-text-header {
  display: flex;
  flex-direction: column;
}

.core-input-text.input-text-format--outside .input-text-header {
  padding: var(--number-spacing-none) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall);
}

.core-input-text.input-text-format--aside .input-text-header {
  flex: 1;
  padding-right: var(--number-spacing-small);
  justify-content: center;
}

.core-input-text .input-text-wrapper {
  flex: 1;
}

.core-input-text .label {
  display: flex;
  align-items: center;
  color: var(--color-edition-content-default);
  transition: color var(--motion-duration-fast) var(--motion-easing-move);
}

.core-input-text .description {
  color: var(--color-neutral-content-medium);
}

.core-input-text.input-text-in-error .label {
  color: var(--color-status-content-error);
}

.core-input-text .field-requirement {
  padding-left: var(--number-spacing-4xsmall);
}

.core-input-text .error-message {
  padding: var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-none) var(--number-spacing-4xsmall);
  color: var(--color-status-content-error);
}

.core-input-text .input-text-field {
  display: flex;
  align-items: center;
  border-radius: var(--number-radius-small);
  border: var(--border-width) solid var(--color-edition-border-default);
  background: var(--color-edition-background-default);
  color: var(--color-neutral-content-strong);
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-input-text input {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  text-indent: inherit;
  text-overflow: inherit;
  text-transform: inherit;
  text-align: inherit;
  white-space: inherit;
  color: inherit;
  display: inline-block;
  position: relative;
  flex: 1;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  appearance: none;
  z-index: 1;
}

.core-input-text input::placeholder {
  color: var(--color-neutral-content-strong);
  /* mozilla is applying transparency on placeholder */
  opacity: 0.65;
}

.core-input-text .input-text-field:not(.core-input-text.input-text-in-error .input-text-field):hover, .core-input-text.input-text-focus .input-text-field:has(:focus) {
  border: var(--border-width) solid var(--color-edition-border-interacting);
  color: var(--color-neutral-content-strong);
  outline: none;
}

.core-input-text.input-text-focus .input-text-field:has(:focus-visible) {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
}

.core-input-text .input-text-field:not(.core-input-text.input-text-in-error .input-text-field):hover .label,
.core-input-text.input-text-focus .label,
.core-input-text:has(.input-text-field:not(.input-text-in-error .input-text-field):hover) .label,
.core-input-text:has(.input-text-field:not(.input-text-in-error .input-text-field):focus-visible) .label {
  color: var(--color-edition-content-interacting);
}

.core-input-text .field-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.core-input-text .field-indicator {
  display: flex;
  align-items: center;
  cursor: default;
}

.core-input-text .icon-box {
  display: flex;
  padding: var(--number-spacing-5xsmall);
}


.core-input-text *[slot="before"] {
  padding-right: var(--number-spacing-2xsmall);
}


.core-input-text *[slot="after"] {
  padding-left: var(--number-spacing-2xsmall);
}
